import { Button } from "@swot/base-components";

export function SwotConflictState(props: { readonly title?: string | undefined; readonly message?: string | undefined; readonly onRefresh?: (() => void) | undefined }) {
  return (
    <section className="swot-conflict-state" role="alert">
      <h2>{props.title ?? "Conflict detected"}</h2>
      <p>{props.message ?? "The request conflicts with the latest backend state."}</p>
      {props.onRefresh ? <Button label="Refresh latest state" variant="secondary" onClick={props.onRefresh} /> : null}
    </section>
  );
}
